import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { DataService } from 'src/app/services/data.service';
import { IActivity } from 'src/app/interfaces/resource';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ConvertService, pushObjArray } from 'src/app/services/convert.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-add-conversation',
  templateUrl: './add-conversation.component.html',
  styleUrls: ['./add-conversation.component.scss']
})
export class AddConversationComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
  TITLE = "Create new conversation"
  form: FormGroup;
  speaker: AbstractControl;
  script: AbstractControl;
  forStudent: AbstractControl


  SELECTED_SOUND_FILE: any;
  uploadPercentSound: Observable<number>
  START_UPLOAD: boolean = false;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;

  SPEAKER_LIST: any[];
  constructor(
    public dialogRef: MatDialogRef<AddConversationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: ActivityStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
  ) { }

  ngOnInit() {
    const { CONVERSATION, ITEM } = this.data;
    this.SPEAKER_LIST = ITEM ? ITEM.speakers : [];
    this.form = this.fb.group({
      script: [CONVERSATION ? CONVERSATION.script : null, Validators.compose([Validators.required])],
      speaker: [CONVERSATION ? CONVERSATION.speaker : this.SPEAKER_LIST[0], Validators.compose([Validators.required])],
      forStudent: [CONVERSATION ? CONVERSATION.forStudent : false, Validators.required]
    })
    if (CONVERSATION) {
      this.TITLE = "Edit conversation"
    }
  }
  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.key === o2.key;
  }

  uploadFileSound(event) {
    this.SELECTED_SOUND_FILE = event;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    const { FORM, SKILL, ACTIVITY_TYPE, MODULE_KEY, ITEM, CONVERSATION, ACTIVITY_TYPE_OBJECT, SKILL_NAME } = this.data;
    if (!this.SELECTED_SOUND_FILE && !CONVERSATION) {
      alert('Please select sound file');
      return;
    }
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      this.START_UPLOAD = true;
      const key = ITEM ? ITEM.key : this.ds.createId();
      const wordKey = CONVERSATION ? CONVERSATION.key : this.ds.createId();
      const { script, forStudent, speaker } = f;
      const { name, instruction, defaultInstruction, youtubeId, languageNotes,reading } = FORM;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;

      if (this.SELECTED_SOUND_FILE) {
        //SOUND
        const soundPath = `${MODULE_KEY}/${key}/${MODULE_KEY}/${wordKey}`;
        const soundTask = this.storage.uploadFile(this.SELECTED_SOUND_FILE, soundPath);
        this.uploadPercentSound = soundTask.percentageChanges();
        const downloadURLSound = (await soundTask).ref.getDownloadURL();
        downloadURLSound.then(soundUrl => {
          const { conversations } = ITEM;
          const conversationData = {
            speaker: speaker,
            forStudent: forStudent,
            script: `${script}`.trim(),
            key: wordKey,
            soundDownloadURL: soundUrl,
            page_key: ConvertService.pageKey(),
          }
          const CONVERSATION_DATA = pushObjArray(conversations, conversationData)
          const activity: IActivity = {
            key: key,
            status: DISPLAY_STATUS_OBJECT.ACTIVE,
            isDelete: false,
            created_at: ITEM ? ITEM.created_at : new Date(),
            created_by: ITEM ? ITEM.created_by : user.uid,
            updated_at: new Date(),
            updated_by: user.uid,
            date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
            page_key: ConvertService.pageKey(),
            keyword: null,
            organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
            organizationKey: selectedCompanyKey,
            created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
            updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
            register_status: registerStatus,
            //fields
            name: name || null,
            reading:reading || null,
            instruction: instruction || null,
            youtubeId: youtubeId || null,
            defaultInstruction: defaultInstruction || false,
            speakers: ITEM ? ITEM.speakers || [] : [],
            languageNotes: languageNotes || null,
            pictureDownloadURL: ITEM ? ITEM.pictureDownloadURL || null : null,
            conversations: CONVERSATION_DATA,
            hasSubActivity: false,
            //modules
            skillKey: SKILL,
            skillName: SKILL_NAME,
            skillRef: this.ds.skillRef().doc(SKILL).ref,
            activityTypeKey: ACTIVITY_TYPE,
            activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
            activityTypeName: ACTIVITY_TYPE_OBJECT.name,
            moduleKey: MODULE_KEY,
            moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
          }

          this.store.addItem(activity,this.data.MODULE, true, (success, res) => {
            this.data.ITEM = activity;
            this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
            if (!isNew) {
              this.dialogRef.close('no')
              return;
            }
            this.form.reset();
            this.form.enable();
            this.form.patchValue({ isFill: false, speaker })
            this.processNew = false;
            this.processClose = false;
            this.isCreate = false;
            this.inputEl.nativeElement.focus()
            this.START_UPLOAD = false;
          })
        }).catch(error => {
          alert(error);
        })
      }
      else {
        const { conversations } = ITEM;
        const conversationData = {
          speaker: speaker,
          forStudent: forStudent,
          script: `${script}`.trim(),
          key: wordKey,
          soundDownloadURL: CONVERSATION.soundDownloadURL,
          page_key: CONVERSATION.page_key,
        }
        const CONVERSATION_DATA = pushObjArray(conversations, conversationData)
        const activity: IActivity = {
          key: key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: ITEM ? ITEM.created_at : new Date(),
          created_by: ITEM ? ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          reading:reading || null,
          instruction: instruction || null,
          youtubeId: youtubeId || null,
          defaultInstruction: defaultInstruction || false,
          speakers: ITEM ? ITEM.speakers || [] : [],
          languageNotes: languageNotes || null,
          pictureDownloadURL: ITEM ? ITEM.pictureDownloadURL || null : null,
          conversations: CONVERSATION_DATA,
          hasSubActivity: false,
          //modules
          skillKey: SKILL,
          skillRef: this.ds.skillRef().doc(SKILL).ref,
          skillName:SKILL_NAME,
          activityTypeKey: ACTIVITY_TYPE,
          activityTypeRef: this.ds.activityTypeRef().doc(ACTIVITY_TYPE).ref,
          activityTypeName: ACTIVITY_TYPE_OBJECT.name,
          moduleKey: MODULE_KEY,
          moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(MODULE_KEY).ref,
        }
        this.store.addItem(activity,this.data.MODULE, true, (success, res) => {
          this.data.ITEM = activity;
          this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
          this.form.reset();
          this.form.enable();
          this.form.patchValue({ isFill: false, speaker })
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.inputEl.nativeElement.focus()
          this.START_UPLOAD = false;
          this.dialogRef.close('no')

        })
      }

    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}